export { default } from './main-menu-link';
